app.controller("CopyGradeTemplateController", [
    "$scope", "GradeTemplate", "$uibModalInstance", "params", "toastr",
    function ($scope, GradeTemplate, $uibModalInstance, params, toastr) {

        $scope.name = params.gradeTemplate.name;
        $scope.code = params.gradeTemplate.code;

        $scope.submit = function () {

            GradeTemplate.copy(params.gradeTemplate._id, {
                name: $scope.name,
                code: $scope.code
            }).then(function (data) {
                if(data.status === "ok") {
                    $uibModalInstance.close();
                } else if(data.status === "error") {
                    var message = "დაფიქსირდა შეცდომა"
                    if(data.message === "ALREADY_EXISTS") {
                        message = "შაბლონი ამ კოდით უკვე არსებობს"
                    }
                    toastr.error(message);
                }
            }).catch(function () {
                $uibModalInstance.dismiss();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

    }
]);
